var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeigehat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 714 362.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ba8e70;}.cls-2{fill:#a67f63;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184,106l67.6-84.25C262.51,8.16,280.83,0,300.44,0H418.65c17.56,0,34.2,6.55,45.36,17.85L542,111Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M357,66C159.83,66,0,148.38,0,250c0,42.41,27.85,81.47,74.64,112.59C79,317.14,94,240.85,145.78,195c35.58-31.5,73.66-53.92,107.57-65.38h0a184.32,184.32,0,0,1,21.53-5.92c32.92-8,98.77-20,163.19-7.84h0c41.21,5.42,94.76,35.14,142.26,82.64,47.16,47.16,60,117.43,63.1,161.29C687.76,329.17,714,291.16,714,250,714,148.38,554.17,66,357,66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeigehat);
export default __webpack_public_path__ + "static/media/beige hat.057f28bc.svg";
export { ForwardRef as ReactComponent };